import { FORM_ERROR } from 'final-form';
import { formRegisterMeasurementFields } from '../../constants/formRegister';
import { schema } from 'normalizr';
import { measurement } from '../../schemas';
import * as actionTypes from '../../constants/productionUnitActionTypes';
import { identity } from 'lodash';
import { createAsyncAction, normalizeHelper } from '../../utils/asyncHelpers';
import {
  productionUnitMeasurementFetch,
  productionUnitMeasurementPointsFetch,
  productionUnitAddMeasurementPoint,
  productionUnitRemoveMeasurementPoint,
  meteringPointUpdate,
  meteringPointDelete,
} from '../actionHelpers/endpoints';
import { meteringPointFields } from '../../constants/meteringPoint';
import { meteringPointDataSource } from '../../constants/classificators';
import {
  toggleMeasurementForm,
  selectMeasurement as selectMeasurementPure,
} from '../pureActions/productionUnitActions';

const simpleMeasurement = new schema.Entity('measurement');

export const fetchProductionUnitMeasurement = createAsyncAction(
  actionTypes.PRODUCTION_UNIT_MEASUREMENT_FETCH,
  productionUnitMeasurementFetch,
  normalizeHelper([simpleMeasurement])
);

export const addProductionUnitMeasurement = createAsyncAction(
  actionTypes.PRODUCTION_UNIT_MEASUREMENT_ADD,
  meteringPointUpdate,
  normalizeHelper(measurement)
);

export const updateProductionUnitMeasurement = createAsyncAction(
  actionTypes.PRODUCTION_UNIT_MEASUREMENT_UPDATE,
  meteringPointUpdate,
  normalizeHelper(measurement)
);

export const editProductionUnitMeasurement = createAsyncAction(
  actionTypes.PRODUCTION_UNIT_MEASUREMENT_EDIT,
  identity,
  normalizeHelper(measurement)
);

export const deleteProductionUnitMeasurement = createAsyncAction(
  actionTypes.PRODUCTION_UNIT_MEASUREMENT_DELETE,
  meteringPointDelete
);

export const onMetringFormSubmit = (values, closeForm) => async (dispatch) => {
  let result;
  if (values[formRegisterMeasurementFields.ID]) {
    if (
      !values[formRegisterMeasurementFields.PRODUCTION_UNIT_ID] &&
      !values[meteringPointFields.CONSUMER]
    ) {
      result = await dispatch(editProductionUnitMeasurement(values));
    } else {
      result = await dispatch(updateProductionUnitMeasurement(values));
    }
  } else if (values[formRegisterMeasurementFields.PRODUCTION_UNIT_ID]) {
    result = await dispatch(
      updateProductionUnitMeasurement({
        ...values,
        [meteringPointFields.DATA_SOURCE]:
          values[meteringPointFields.DATA_SOURCE] ||
          meteringPointDataSource.VIRTUAL,
      })
    );
  } else {
    const newValues = { ...values };
    delete newValues[formRegisterMeasurementFields.ID];
    result = await dispatch(
      addProductionUnitMeasurement({
        ...newValues,
        [meteringPointFields.DATA_SOURCE]: meteringPointDataSource.VIRTUAL,
      })
    );
  }
  if (result?.error) {
    return { [FORM_ERROR]: 'submitFailed' };
  }
  closeForm();
};

export const fetchProductionUnitMeasurementPoints = createAsyncAction(
  actionTypes.PRODUCTION_UNIT_MEASUREMENT_POINTS_FETCH,
  productionUnitMeasurementPointsFetch,
  normalizeHelper([simpleMeasurement])
);

export const addMeasurementPointToProductionUnit = createAsyncAction(
  actionTypes.PRODUCTION_UNIT_ADD_MEASUREMENT_POINT,
  productionUnitAddMeasurementPoint,
  normalizeHelper(simpleMeasurement)
);

export const removeMeasurementPointFromProductionUnit = createAsyncAction(
  actionTypes.PRODUCTION_UNIT_REMOVE_MEASUREMENT_POINT,
  productionUnitRemoveMeasurementPoint
);

export const showMeasurementForm = () => (dispatch) =>
  dispatch(toggleMeasurementForm(true));
export const hideMeasurementForm = () => (dispatch) =>
  dispatch(toggleMeasurementForm(false));

export const selectMeasurement = (measurementId) => (dispatch) =>
  dispatch(selectMeasurementPure(measurementId));
